import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LoginPage } from './LoginPage';

/** Route wrapper: the new iVilotid login at /login (replaces the old login). */
const LoginScreen: React.FC = () => {
  const navigate = useNavigate();
  return (
    <LoginPage
      onBack={() => navigate('/')}
      onRegister={() => navigate('/register-company')}
    />
  );
};

export default LoginScreen;
